// Libraries
import React, { useContext } from 'react';

// Services and contexts
import LanguageContext from '../contexts/LanguageContext';

// Material-UI
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

export default function Copyright() {
  const { translate } = useContext(LanguageContext);

  return (
    <Box margin={3} textAlign="center">
      <Typography variant="body2" color="textSecondary">
        {translate('GLOBAL_COPYRIGHT')}
        <span style={{ margin: '0 0.5rem' }}>|</span>
        <Link href="https://www.intellisense.io/terms" target="_blank" rel="noopener">
          {translate('GLOBAL_TERMS_AND_CONDITIONS')}
        </Link>
      </Typography>
    </Box>
  );
}
